import React from 'react';
import { Navigate } from 'react-router-dom';
import { isClientUser, isBeneficiaryUser, hasAdminAccess, getClientIdFromEmail, getClientIdFromBeneficiary } from '../utils/userRole';
import { getFirestore } from 'firebase/firestore';

/**
 * Route protégée pour l'administration - redirige les clients vers leur dashboard
 * et les utilisateurs non autorisés vers la page d'accueil
 */
function AdminRoute({ user, children }) {
  const db = getFirestore();
  const [hasAccess, setHasAccess] = React.useState(null);
  const [redirectPath, setRedirectPath] = React.useState(null);

  React.useEffect(() => {
    const checkAccess = async () => {
      if (!user) return;

      // Vérifier si c'est un client (ancienne méthode)
      if (isClientUser(user.email)) {
        const clientId = getClientIdFromEmail(user.email);
        setRedirectPath(`/client-dashboard/${clientId}`);
        setHasAccess(false);
        return;
      }

      // Vérifier si c'est un bénéficiaire (nouveau système)
      const isBeneficiary = await isBeneficiaryUser(db, user.uid);
      if (isBeneficiary) {
        const clientId = await getClientIdFromBeneficiary(db, user.uid);
        if (clientId) {
          setRedirectPath(`/client-dashboard/${clientId}`);
        }
        setHasAccess(false);
        return;
      }

      // Vérifier les permissions admin
      const access = await hasAdminAccess(db, user);
      setHasAccess(access);
    };

    checkAccess();
  }, [user, db]);

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Si une redirection est nécessaire (client ou bénéficiaire)
  if (redirectPath) {
    return <Navigate to={redirectPath} />;
  }

  // En attendant la vérification, afficher un loader
  if (hasAccess === null) {
    return <div className="flex items-center justify-center h-screen">Vérification des permissions...</div>;
  }

  // Si l'utilisateur a accès, afficher le contenu
  if (hasAccess) {
    return children;
  }

  // Si l'utilisateur n'a pas accès, rediriger vers le dashboard
  return <Navigate to="/dashboard" />;
}

export default AdminRoute;
